import config from "../config";
import { TwilioAccountListRequest } from "../types/TwilioAccount";
import { requests } from ".";

const subdomainTwilio = "/conversations/providers/twilio";

export const TwilioAccountService = {
  list: async (options: TwilioAccountListRequest) => {
    const { companyId, deleted, skip, limit, query } = { ...options };
    const { data } = await requests(config.MARKETPLACE_REST_API_URL).get(
      `${subdomainTwilio}?companyId=${companyId}${`&deleted=${deleted ?? false}`}${
        skip ? `&skip=${skip}` : ""
      }${limit ? `&limit=${limit}` : ""}${query ? `&query=${encodeURIComponent(query)}` : ""}`
    );
    return data;
  },

  getAgencyTwilio: async (companyId) => {
    const { data } = await requests(config.MARKETPLACE_REST_API_URL).get(
      `${subdomainTwilio}/fetch?companyId=${companyId}`
    );
    return data;
  },

  getLocationTwilio: async (locationId) => {
    const { data } = await requests(config.MARKETPLACE_REST_API_URL).get(
      `${subdomainTwilio}/fetch?locationId=${locationId}`
    );
    return data;
  },

  updateAgencyTwilio: async (payload: { [key: string]: any }, companyId) => {
    const { data } = await requests(config.MARKETPLACE_REST_API_URL).post(
      `${subdomainTwilio}?companyId=${companyId}`,
      payload
    );
    return data;
  },

  updateSubAccountTwilio: async (payload: { [key: string]: any }, locationId) => {
    const { data } = await requests(config.MARKETPLACE_REST_API_URL).post(
      `${subdomainTwilio}?locationId=${locationId}`,
      payload
    );
    return data;
  },

  checkAccountToken: async ({accountSid, accountToken}) => {
    const res = await requests(config.APP_ENGINE_API_URL).get(
      `/twilio/checkAccount?account_sid=${accountSid}&account_token=${accountToken}`,
      );
    return res;
  },

  editSubAccountTwilio: async (payload: { [key: string]: any }, locationId) => {
    const { data } = await requests(config.APP_ENGINE_API_URL).post(
      `/twilio/edit?location_id=${locationId}`,
      payload
    );
    return data;
  },

  validateSubAccountSMS: async (payload: { [key: string]: any }, locationId) => {
    try {
      const { data } = await requests(config.APP_ENGINE_API_URL).post(
        `/twilio/subaccount/${locationId}/validate_sms`,
        payload
        );

      return Promise.resolve(data)

    } catch (error) {
      return Promise.resolve(error)
    }
  },

  delete: async (companyId?, locationId?, close?) => {
    const { data } = await requests(config.MARKETPLACE_REST_API_URL).delete(
      `${subdomainTwilio}${companyId ? `?companyId=${companyId}` : "?"}${
        locationId ? `${companyId ? "&" : ""}locationId=${locationId}` : ""
      }${close ? "" : "&dont_close_twilio=true"}`
    );
    return data;
  },

  fetch: async (companyId?, locationId?) => {
    const { data } = await requests(config.MARKETPLACE_REST_API_URL).get(
      `${subdomainTwilio}/fetch${companyId ? `?companyId=${companyId}` : ""}${
        locationId ? `&locationId=${locationId}` : ""
      }`
    );
    return data;
  },

  createSubAccount: async (locationId) => {
    const { data } = await requests(config.MARKETPLACE_REST_API_URL).post(
      `${subdomainTwilio}/setup/subaccount?locationId=${locationId}`,
      {}
    );
    return data;
  },

  enableISVModeForLocation: async (payload) => {
    const { user, locationId } = payload;
    const { data } = await requests(config.APP_ENGINE_API_URL).post(
      `/twilio/migrate_subaccount/${locationId}`,
      {
        user: {
          ...user,
          name: user.name,
        },
      }
    );
    return data;
  },

  bulkEnableISVModeForLocation: async (payload) => {
    const { user, companyId } = payload;
    const { data } = await requests(config.APP_ENGINE_API_URL).post(
      `/twilio/migrate_subaccount_bulk/${companyId}`,
      {
        user: {
          ...user,
          name: user.name,
        },
      }
    );
    return data;
  },
  enableISVModeForCompany: async (companyId, stripe, purchaseDescription) => {
    const payload ={
      entityId: companyId,
      entityType: "COMPANY",
      amount: 1,
      currency: "USD",
      description: purchaseDescription,
      enable3DS: true
    }
    try {
      const { data } = await requests(config.MARKETPLACE_REST_API_URL).post(
        `/internal-tools/billing/payment-intent`, payload
      );

      const { paymentIntent, paymentMethod } = data;

      const confirmation = await stripe.confirmCardPayment(paymentIntent.clientSecret, {
        payment_method: paymentMethod,
      });

      if (!confirmation?.paymentIntent) {
        return Promise.reject(confirmation.error);
      }

      const res = await  requests(config.SAAS).get(
        `/isv-mode/enable-isv-mode/${companyId}?paymentIntentId=${confirmation.paymentIntent?.id}`
      );
      return Promise.resolve(res.data);
    } catch (error) {
      return Promise.reject(error);
    }
  },
};
